import ActiveCampaignPage, { Props } from './CampaignPage'
import DisabledCampaignPage from './DisabledCampaignPage'

const disabledCampaigns: string[] = []

const CampaignPage = ({ campaign, ...rest }: Props) => {
  if (disabledCampaigns.includes(campaign.slug)) {
    return <DisabledCampaignPage campaign={campaign} />
  }
  return <ActiveCampaignPage campaign={campaign} {...rest} />
}

export default CampaignPage
